import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import {PortTheme} from "~/ui/theme";
import {Card, CardActionArea, CardContent, Divider, Grid, Typography} from "@mui/material";
import {formatDate} from "~/apps/core/utils";
import moment from "moment/moment";
import {TypographyWithIcon} from "~/apps/core/ui/TypographyWithIcon";
import {LockClose} from "~/ui/icons";
import {TypographyWithLabel} from "~/apps/core/ui/TypographyWithLabel";
import {NavigateNext} from "@mui/icons-material";
import {OrdersListStatusBadge} from "~/apps/packages/auto-shipment-orders/components/OrdersList/OrdersListStatusBadge";
import {OrderItem} from "~/apps/packages/auto-shipment-orders/queries";
import {Tag} from "~/apps/core/ui/Tag";

const useStyles = makeStyles<PortTheme>(theme => ({
    root: {
        width: "100%",
    },
}));

type OffersListItemProps = {
    offer: OrderItem,
}

export const OrdersListItem = (props: OffersListItemProps) => {
    const {offer} = props;
    const classes = useStyles(props);

    return (
        <Card className={classes.root}>
            <CardActionArea>
                <CardContent>
                    <Grid container direction="column" rowSpacing="8px" wrap="nowrap">
                        <Grid item container direction="column" wrap="nowrap" rowSpacing="8px">
                            <Grid item container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <OrdersListStatusBadge>
                                        {offer.status}
                                    </OrdersListStatusBadge>
                                </Grid>
                                <Grid item>
                                    <Typography variant="cardText">
                                        {formatDate(moment(offer.date, "YYYY-MM-DD"))}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction="row" justifyContent="space-between">
                                <Grid item>
                                    <Typography variant="cardTitle2" color="#081F32">
                                        {offer.number}
                                    </Typography>
                                </Grid>
                                {offer.pin && (
                                    <Grid item>
                                        <TypographyWithIcon variant="cardText" color="additionalPrimary.main"
                                                            startIcon={<LockClose style={{width: 16, height: 16}}/>}>
                                            PIN {offer.pin || <>&ndash;&ndash;&ndash;&ndash;</>}
                                        </TypographyWithIcon>
                                    </Grid>
                                )}
                            </Grid>
                            {offer.shipmentByConsignee && <Grid item>
                                <Tag>
                                    Вывоз грузополучателем
                                </Tag>
                            </Grid>}
                        </Grid>
                        <Grid item>
                            <Divider/>
                        </Grid>
                        <Grid item>
                            <TypographyWithLabel
                                label="Название груза"
                                noWrap={false}
                                sx={{
                                    display: '-webkit-box',
                                    overflow: 'hidden',
                                    WebkitBoxOrient: 'vertical',
                                    WebkitLineClamp: 5,
                                }}
                            >
                                {offer.cargoInfo || <>&ndash;</>}
                            </TypographyWithLabel>

                        </Grid>

                        <Grid item container direction="row" justifyContent="space-between" alignItems="flex-end">
                            <Grid item>
                                <Grid item>
                                    {offer.shipmentByConsignee
                                        ? (<TypographyWithLabel label="Грузополучатель" noWrap={false}>
                                            {offer.consignee}
                                            </TypographyWithLabel>)
                                        : (<TypographyWithLabel label="Перевозчик" noWrap={false}>
                                        {offer.carrier}
                                    </TypographyWithLabel>)}
                                </Grid>
                            </Grid>
                            <Grid item>
                                <TypographyWithIcon endIcon={<NavigateNext/>} color="textSecondary" variant="cardText" marginRight="-8px" marginBottom="-2px">
                                    Подробнее
                                </TypographyWithIcon>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
